export const rdscLogin = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/user/login`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const rdscGetHospitalList = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/user/getHospitalList`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const rdscGetExpertInfo = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/user/getExpertInfo`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const rdscGetStudyList = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/study/getStudy`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const rdscGetThisHosStudyList = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/study/getThisHosStudyList`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//接片
export const rdscEditStudy = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/study/editStudy`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//接片
export const rdscModifyThisHosStudyByStudyUid = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/study/modifyThisHosStudyByStudyUid`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//
export const rdscGetThisHosStudyByStudyUid = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/study/getThisHosStudyByStudyUid`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//
export const rdscGetHosDoctorReport = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/study/getHosDoctorReport`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//
export const rdscAddExpertReportReviewOpinion = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/study/addExpertReportReviewOpinion`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//
export const rdscModifyHosDoctorReportByStudyUId = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/study/modifyHosDoctorReportByStudyUId`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//
export const rdscGetStudyByStudyUId = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/study/getStudyByStudyUId`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const rdscGetReportByparams = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/report/getReportByparams`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const rdscGetTree = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/tree/getTree`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const rdscSaveReport = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(post),
  };
  return fetch(`/rdscapi/report/saveReport`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//
export const rdscGetReportTemplateInfo = id => {
  const init = {
    method: 'POST',
  };
  return fetch(`/rdscapi/tree/getReportTemplateInfo?id=${id}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//
export const rdscCountHopital = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  return fetch(`/rdscapi/statistics/countHospital`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
//
export const rdscCountExpert = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  return fetch(`/rdscapi/statistics/countExpert`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
